'use client'
import {
  BUTTON_QUERY
} from "./chunk-OYEMYN5L.mjs";
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";

// src/api/common/card.ts
var CARD_QUERY = `
id
title
titleLine2
subtitle
subtitleLine2
description
button {${BUTTON_QUERY}}
image31{${IMAGE_QUERY}}
image11{${IMAGE_QUERY}}
icon{${IMAGE_QUERY}}
background{${IMAGE_QUERY}}
`;

export {
  CARD_QUERY
};
//# sourceMappingURL=chunk-3CM7PDLU.mjs.map